var map = {
	"./about-us-banner.webp": 217,
	"./anniversary-banner-bm.webp": 1543,
	"./anniversary-banner-cn.webp": 1544,
	"./anniversary-banner-id.webp": 1545,
	"./anniversary-banner.webp": 1546,
	"./banner-01.jpg": 1547,
	"./banner-slot.jpg": 1548,
	"./bet-and-earn-banner-cn.webp": 1549,
	"./bet-and-earn-banner-indon.webp": 1550,
	"./bet-and-earn-banner-ms.webp": 1551,
	"./bet-and-earn-banner.webp": 1552,
	"./check-in-banner-cn.webp": 1553,
	"./check-in-banner-id.webp": 1554,
	"./check-in-banner-ms.webp": 1555,
	"./check-in-banner.webp": 1556,
	"./cny_2024-bm.webp": 1557,
	"./cny_2024-cn.webp": 1558,
	"./cny_2024.webp": 1559,
	"./epl-banner-cn.jpg": 1560,
	"./epl-banner-cn.webp": 1561,
	"./epl-banner-indo.jpg": 1562,
	"./epl-banner-indo.webp": 1563,
	"./epl-banner-ms.jpg": 1564,
	"./epl-banner-ms.webp": 1565,
	"./epl-banner.jpg": 1566,
	"./epl-banner.webp": 1567,
	"./games-banner-bm.webp": 1568,
	"./games-banner-cn.webp": 1569,
	"./games-banner-id.webp": 1570,
	"./games-banner.webp": 1571,
	"./lb-m-banner-cn.webp": 1572,
	"./lb-m-banner.webp": 1573,
	"./leaderboard-banner-cn.webp": 1574,
	"./leaderboard-banner.webp": 1575,
	"./lottery-banner.webp": 1576,
	"./lottery-banners-bm.webp": 1577,
	"./lottery-banners-cn.webp": 1578,
	"./lottery-banners-id.webp": 1579,
	"./lottery-banners.webp": 1580,
	"./lucky-spin-banner-cn.webp": 1581,
	"./lucky-spin-banner-ms.webp": 1582,
	"./lucky-spin-banner-vn.webp": 1583,
	"./lucky-spin-banner.webp": 1584,
	"./p2p-banner.webp": 1585,
	"./p2p-banners-bm.webp": 1586,
	"./p2p-banners-cn.webp": 1587,
	"./p2p-banners-id.webp": 1588,
	"./p2p-banners.webp": 1589,
	"./premier-league-banner-cn.webp": 1590,
	"./premier-league-banner.webp": 1591,
	"./promos-banner-cn.webp": 1592,
	"./promos-banner-indon.webp": 1593,
	"./promos-banner-ms.webp": 1594,
	"./promos-banner.webp": 1595,
	"./promos-detail-banner.jpg": 1596,
	"./side-bar-banner.jpg": 1597,
	"./uefa24-prediction-bm.webp": 1598,
	"./uefa24-prediction-cn.webp": 1599,
	"./uefa24-prediction-id.webp": 1600,
	"./uefa24-prediction.webp": 1601,
	"./vip-banner-cn.webp": 1602,
	"./vip-banner-id.webp": 1603,
	"./vip-banner-ms.webp": 1604,
	"./vip-banner-vn.webp": 1605,
	"./vip-banner.webp": 1606,
	"./winner-leaderboard-banner-cn.webp": 1607,
	"./winner-leaderboard-banner.webp": 1608,
	"./world-cup-banner-cn.webp": 1609,
	"./world-cup-banner.webp": 1610,
	"./world-cup-two-banner-cn.webp": 1611,
	"./world-cup-two-banner.webp": 1612,
	"./xmas_2023-bm.jpg": 1613,
	"./xmas_2023-cn.jpg": 1614,
	"./xmas_2023-id.jpg": 1615,
	"./xmas_2023.jpg": 1616,
	"./xmas_2024-bm.webp": 1617,
	"./xmas_2024-cn.webp": 1618,
	"./xmas_2024.webp": 1619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;